export const completaNif = function(n) {
  "use strict";
  const str = `${n}`;
  if (str.length < 8) {
    return str;
  }
  let calcular = true;
  for (let i = 0; i < 8; i++) {
    const n = str.charCodeAt(i);
    if (n < 48 || n > 57) {
      calcular = false;
      break;
    }
  }
  if (!calcular) {
    return str;
  }
  const cadena = "TRWAGMYFPDXBNJZSQVHLCKET";
  const posicion = str % 23;
  return `${str.substr(0, 8)}${cadena.substring(posicion, posicion + 1)}`;
};

export const aleatorioId = function(uid) {
  let result = "";
  let uidTri = Math.floor(uid.length / 3);
  uidTri = uidTri > 9 ? 9 : uidTri;
  const cadena = [
    uid.slice(0, uidTri),
    uid.slice(uidTri, uidTri * 2),
    uid.slice(uidTri * 2, uid.length)
  ];
  for (let index = 0; index < 3; index++) {
    const i = Math.floor(Math.random() * uidTri);
    const cad = cadena[index].substr(i, 1);
    result += `${i}${cad}`;
  }
  result += `${uidTri}-`;
  return result;
};

export const fechaObject = function(dd = null) {
  let d = new Date();
  if (dd) {
    if (d.getHours() === dd.getHours()) {
      d = dd;
    }
  }
  let dia = `0${d.getUTCDate()}`;
  let mes = `0${d.getMonth() + 1}`;
  const year = d.getFullYear();
  let hora = `0${d.getHours()}`;
  let minuto = `0${d.getMinutes()}`;
  let segundo = `0${d.getSeconds()}`;

  dia = dia.substr(-2, 2);
  mes = mes.substr(-2, 2);
  hora = hora.substr(-2, 2);
  minuto = minuto.substr(-2, 2);
  segundo = segundo.substr(-2, 2);

  const result = {
    formatEU: `${dia}/${mes}/${year}`,
    formatEUextend: `${year}${mes}${dia}${hora}${minuto}${segundo}`,
    timeStamp: d.getTime()
  };

  return result;
};
